module.exports = __webpack_public_path__ + "img/boqinspect5_7-8-2021.46a2c64d.jpg";